import createCache from "@emotion/cache";

export default function createEmotionCache() {
  const nonce =
    document.querySelector("meta[name='csp-nonce']")?.getAttribute("content");

  return createCache({
    key: "emotion-key",
    nonce,
    prepend: true,
    speedy: true,
  });
}
